"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
/**
 * Created by Hayk.Andriasyan on 5/19/2018.
 */
var DefaultTextStyleDtoFactory = /** @class */ (function () {
    function DefaultTextStyleDtoFactory() {
    }
    DefaultTextStyleDtoFactory.getDefaultTextStyle = function () {
        var textStyle = new idm_report_export_service_client_js_1.TextStyleDto();
        textStyle.fontSize = 12;
        textStyle.fontName = idm_report_export_service_client_js_1.FontName.ROBOTO;
        textStyle.color = 'rgba(0, 0, 0, 0.87)';
        textStyle.backgroundColor = null;
        textStyle.isBold = false;
        textStyle.isUnderline = false;
        textStyle.isItalic = false;
        textStyle.align = undefined;
        return textStyle;
    };
    return DefaultTextStyleDtoFactory;
}());
exports.DefaultTextStyleDtoFactory = DefaultTextStyleDtoFactory;
//# sourceMappingURL=default-text-style-dto-factory.js.map